import { Injectable } from '@angular/core';

import { SelectedOfferService } from './impl/section-services/selected-offer/selected-offer.service';
import { AdditionalInformationStateService } from './impl/section-services/additional-information/additional-information-state.service';
import { AdditionalInformationSectionConsts } from '../../shared/sections/web/additional-information-section/additional-information-section.consts';
import { DialogService } from './dialog.service';
import { DialogKey } from '../../shared/components/dialogs/dialogs-configuration';

@Injectable({
  providedIn: 'root'
})
export class GeneraliExceptionService {

  constructor(private selectedOfferService: SelectedOfferService,
              private additionalInformationStateService: AdditionalInformationStateService,
              private dialogService: DialogService) {
  }

  isValid(): boolean {
    if (this.selectedOfferService.hasAC() && (!this.hasImmobilizer())) {
      this.openExceptionDialog();
      return true;
    } else {
      return false;
    }
  }

  private hasAutoAlarm(): boolean {
    return this.findQuestionByCode(AdditionalInformationSectionConsts.AUTOALARM);
  }

  private hasImmobilizer(): boolean {
    return this.findQuestionByCode(AdditionalInformationSectionConsts.IMMOBILIZER);
  }

  private findQuestionByCode(code: string): boolean {
    try {
      return this.additionalInformationStateService.vehicleData.questions.find(({ questionCode }) => questionCode.toLowerCase() === code.toLowerCase()).questionAnswer.toUpperCase().endsWith('YES');
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  private openExceptionDialog(): void {
    this.dialogService.open(DialogKey.MISSING_ANTITHEFT_DEVICE_EXCEPTION);
  }
}
